import { useEffect } from "react";
import { usePostMessage } from "@/hooks/usePostMessage";
import { createRefreshResultHandler } from "@/services/postMessage/handlers/RefreshResultHandler";

export function EmbedRefreshResultListener() {
  const isInIframe = typeof window !== "undefined" && window.self !== window.top;
  const service = usePostMessage({ enabled: isInIframe });

  useEffect(() => {
    if (!service || !isInIframe) return;
    const handler = createRefreshResultHandler();
    const unsubscribe = service.subscribe("REFRESH_RESULT", handler);
    return () => unsubscribe();
  }, [service, isInIframe]);

  return null;
}
